import * as fromStoreAction from '../actions/store.actions';
import {Store} from '../../store';



export interface StoreState {
  entities: Store[];
  entity?: Store;
  loading: boolean;
  loaded: boolean;
  error: string;
}

export const initialState = {
  entities: null,
  loading: false,
  loaded: true,
  error: null,
};

export function reducer(state = initialState, action: fromStoreAction.StoreAction): StoreState {
  switch (action.type) {
    case fromStoreAction.GET_ALL_STORES: {
      return {
        ...state,
        loading: true,
        loaded: false,
        error: null
      };
    }
    case fromStoreAction.GET_ALL_STORES_SUCCESS: {
      return {
        ...state,
        loading: false,
        loaded: true,
        entities: action.payload,
        error: null
      };
    }
    case fromStoreAction.GET_ALL_STORES_ERROR: {
      return {
        ...state,
        loading: false,
        loaded: true,
        entities: null,
        entity: null,
        error: action.payload
      };
    }
    case fromStoreAction.GET_STORE: {
      return {
        ...state,
        loading: true,
        loaded: false,
        error: null
      };
    }
    case fromStoreAction.GET_STORE_SUCCESS: {
      return {
        ...state,
        loading: false,
        loaded: true,
        entity: action.payload,
        error: null
      };
    }
    case fromStoreAction.GET_STORE_ERROR: {
      return {
        ...state,
        loading: false,
        loaded: true,
        entities: null,
        entity: null,
        error: action.payload
      };
    }
    case fromStoreAction.ADD_STORE: {
      return {
        ...state,
        entity: action.payload,
        loading: true,
        loaded: false,
        error: null
      };
    }
    case fromStoreAction.ADD_STORE_SUCCESS: {
      return {
        ...state,
        entity: action.payload,
        loading: false,
        loaded: true,
        error: null
      };
    }
    case fromStoreAction.ADD_STORE_ERROR: {
      return {
        ...state,
        error: action.payload,
        loading: false,
        loaded: true,
      };
    }
    case fromStoreAction.UPDATE_STORE_SUCCESS: {
      if (state.entities) {
        state.entities.filter((store, index) => {
          if (store.id === action.payload.id) {
            state.entities[index] = action.payload;
          }
        });
      }
      return {
        ...state,
        entity: action.payload,
        loading: true,
        loaded: false,
        error: null
      };
    }
    case fromStoreAction.UPDATE_STORE: {
      return {
        ...state,
        entity: action.payload,
        loading: false,
        loaded: true,
        error: null
      };
    }
    case fromStoreAction.UPDATE_STORE_ERROR: {
      return {
        ...state,
        error: action.payload,
        loading: false,
        loaded: true,
      };
    }
  }
  return state;
}



// WEBPACK FOOTER //
// /Users/Chetan/Downloads/angular5_admin-master/src/app/stores/store/reducers/store.reducer.ts